import React, { useContext, useState } from 'react';
import { Row, Col, Button, GreenButton, Pagination, Search } from 'clad';
import { GridContext } from '../Grid';

const toolbarDisabledStyle = {
    opacity: 0.4,
    pointerEvents: 'none',
    minWidth: '550px'
};

const toolbarStyle = {
    minWidth: '550px'
};

const GridToolbar = props => {
    const { loading } = props;
    const context = useContext(GridContext);
    const {
        statePagination,
        searchString: initialSearchString,
        onSearch,
        total,
        onCreate,
        onPagination,
        records,
        redirect,
        onRefresh
    } = context;
    const { current, pageSize } = statePagination.pagination;
    const [searchString, setSearchString] = useState(initialSearchString);

    const handlePagination = (page, pageSize) => {
        onPagination(page, pageSize);
    };

    const handleSearch = strSearch => {
        setSearchString(strSearch);
        onSearch(strSearch);
    };

    const handleCreate = () => {
        onCreate();
    };
    const handleRefresh = () => {
        onRefresh();
    };

    if (!redirect && Boolean(total) && records.length === 0) {
        return <h1>{_('No results')}</h1>;
    }
    return (
        !loading && (
            <Row
                style={
                    statePagination.fetching
                        ? toolbarDisabledStyle
                        : toolbarStyle
                }
            >
                {Boolean(total) ||
                (total === 0 &&
                    (searchString !== null && searchString !== '')) ? (
                    <Col span={8}>
                        <Search
                            allowClear
                            defaultValue={searchString}
                            value={searchString}
                            onChange={e =>
                                setSearchString(e.currentTarget.value)
                            }
                            onSearch={handleSearch}
                            style={{ width: 250 }}
                        />
                    </Col>
                ) : null}

                {Boolean(total) && (
                    <Col span={16} style={{ float: 'right' }}>
                        {onCreate ? (
                            <GreenButton
                                onClick={handleCreate}
                                style={{ marginRight: 5, float: 'inherit' }}
                            >
                                {_('Create')}
                            </GreenButton>
                        ) : null}
                        <Button
                            onClick={handleRefresh}
                            style={{ marginRight: 5, float: 'inherit' }}
                        >
                            {_('Refresh')}
                        </Button>
                        <Pagination
                            simple
                            style={{ marginRight: 8, float: 'inherit' }}
                            defaultCurrent={current}
                            current={current}
                            pageSize={pageSize}
                            total={total || 50}
                            onChange={handlePagination}
                        />
                    </Col>
                )}
            </Row>
        )
    );
};

export default GridToolbar;
